import { exportDataGrid } from "devextreme/excel_exporter";
import saveAs from "file-saver";

export default exportDataGrid;

export const saveAsCustom = (buffer, nombreArchivo) => {
  return saveAs(buffer, nombreArchivo);
};
